import { render, staticRenderFns } from "./ReversedCT.AU.1.vue?vue&type=template&id=18c31a87&scoped=true"
import script from "./ReversedCT.AU.1.vue?vue&type=script&lang=js"
export * from "./ReversedCT.AU.1.vue?vue&type=script&lang=js"
import style0 from "./ReversedCT.AU.1.vue?vue&type=style&index=0&id=18c31a87&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c31a87",
  null
  
)

export default component.exports